import { render, staticRenderFns } from "./SalesTaxSchedule.vue?vue&type=template&id=3a624329&scoped=true&"
import script from "./SalesTaxSchedule.vue?vue&type=script&lang=ts&"
export * from "./SalesTaxSchedule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a624329",
  null
  
)

export default component.exports